import { z } from 'zod';

export const exportNetworkchema = z.string();

export const exportElementsSchema = z.string();
